import { useTranslation } from "react-i18next";

import type { RecurringOrderListSortValue } from "../types";

type SortByOptions = {
  value: RecurringOrderListSortValue;
  label: string;
};

export const useRecurringSortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("order", {
    keyPrefix: "recurringOrderListPage.filters.sortByOptions"
  });

  return [
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    }
  ];
};
